import commonStyles from "../../styles/Common.module.css";
import styles from "./styles/Questions.module.css";

const AddQuestion = () => {
    return (
        <div className={`${styles.MainContainer}`} >
            <div className={commonStyles.headerDiv}>
                <h1>Create New Question</h1>

            </div>
        </div>
    )
}

export default AddQuestion